(function ($) {
	class Block_Blank_Media extends BD_Block {
		constructor() {
			super();

			this.type = "blank_media";
			this.templateID = "blank-media-template";

			this.elms = {
				questionCard: ".questionCard",
				answer: ".js-answer",
				submit: ".js-submit",
				backWrapper: ".questionCard__back",
				back: ".js-back",
			};

			this._events = this.getEvents();
		}

		getEvents() {
			const elms = this.elms;
			return [
				{
					event: "click",
					selector: elms.submit,
					handler: this.submit,
				},
				{
					event: "click",
					selector: elms.back,
					handler: this.back,
				},
			];
		}

		beforeinit() {
			this.render();
			this.setGameState();
			this.setQuestion();
			this.setTimer();
		}

		render() {
			const htmlTemplate = $("#" + this.templateID).html();
			let template = Handlebars.compile(htmlTemplate);

			const html = template(this._data);
			$("#templateWrapper").html(html);
		}

		setGameState() {
			const showBackBtn = () => {
				if(BD_SequenceHistory.data) {
					$(this.elms.backWrapper).addClass('is-active')
				}
			}

			showBackBtn()
		}

		setQuestion() {
			this.question = BD_Question.create(this._data.question)
			this._events = [...this._events, ...this.question.getEvents()];
			this.question.showSubmitBtn(this);
		}

		setTimer() {
			this.timer = new BD_Timer(this._data, this.question);
			this.timer.start();
		}

		back(e) {
			const seqHistory = BD_SequenceHistory.data;
			const currentBlockID = parseInt(BD_GAME_LOGIC.getCurrentBlockID())
			const history = seqHistory[currentBlockID]
			if(!history) return

			BD_GAME_LOGIC.goBack(history.prev)
		}

		submit(e, $el) {
			this.question.submitAnswer($el, this);
		}

		afterDestroy() {
			this.timer.stop();
		}
	}

	return new Block_Blank_Media();
})(jQuery);
